export default __webpack_public_path__ + "static/honeymoon-hammock-4930b3c4b7c65af19aaaaa0a35d875b5.jpg";